import { Pipe, PipeTransform } from '@angular/core';
import { COMMON_CONSTANTS } from 'src/app/common/core/common.constants';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { isNullOrUndefined } from 'src/app/services/utils';

@Pipe({
  name: 'searchPipe'
})
export class SearchPipePipe implements PipeTransform {

  constructor(public manageLineSvc: ManageLineService) {}

  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    const tempArray = items.filter((item) => {
      if (item.hasOwnProperty(COMMON_CONSTANTS.NAME) || item.hasOwnProperty(COMMON_CONSTANTS.DESCRIPTION)) {
        if(!isNullOrUndefined(item.name)){
          return item.name && item.name.toLowerCase().includes(searchText);
        }
        return item.description && item.description.toLowerCase().includes(searchText);
      } else {
        return item && item.toLowerCase().includes(searchText);
      }
    });

    if (tempArray.length === COMMON_CONSTANTS.DIGITS.ZERO) {
      this.manageLineSvc.noRecordsFound.next(true);
    } else {
      this.manageLineSvc.noRecordsFound.next(false);
    }
    return tempArray;
  }

}
